module.exports = __webpack_public_path__ + "static/media/tz.f2abd46e.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/notice/tz.png
// module id = 444
// module chunks = 0